import { useRef } from 'react';
import { useNavigate, useParams, useRouter, useSearch } from '@tanstack/react-router';
import { SupplyPage } from '../../features/supply/ui/SupplyPage.js';
import { SupplyDetailPage } from '../../features/supply/ui/SupplyDetailPage.js';

/**
 * Tushum bo'limining marshrut o'ramlari.
 *
 * Sahifalar marshrutlashni BILMAYDI — ular `onOpen`/`onBack` chaqiradi va
 * yo'lni shu yer beradi. Shu tufayli ikkalasi ham testda marshrutsiz
 * chiziladi va `apps/web` alohida omborga ko'chsa ham o'zgarishsiz qoladi.
 */

export const SUPPLY_PATH = '/supply';

/**
 * `/supply/$reportId?place=1,2` — joylashtirilayotgan satrlar. Router
 * qiymatni JSON sifatida o'qiydi: qo'lda yozilgan `?place=7` son bo'lib
 * keladi va u ham qabul qilinadi.
 */
export const parseSupplyDetailSearch = (search: Record<string, unknown>): { place?: string } => {
  const raw = search['place'];
  const place = typeof raw === 'number' ? String(raw) : raw;
  return typeof place === 'string' && place !== '' ? { place } : {};
};

export const SupplyListRoute = () => {
  const navigate = useNavigate();
  return (
    <SupplyPage
      onOpen={(reportId) => void navigate({ to: '/supply/$reportId', params: { reportId } })}
    />
  );
};

export const SupplyDetailRoute = () => {
  const navigate = useNavigate();
  const router = useRouter();
  const { reportId } = useParams({ from: '/shell/supply/$reportId' });
  const { place } = useSearch({ from: '/shell/supply/$reportId' });

  /* Joylashtirish SHU sahifadan ochilganmi — ya'ni tarixdagi oldingi
     yozuv aynan shu hujjatmi. Havola yoki yangi tab bilan to'g'ridan-
     to'g'ri kelinganda bu `null` bo'ladi va `history.back()` odamni
     boshqa saytga yoki bo'sh tabga olib ketardi. */
  const openedFrom = useRef<string | null>(null);

  const placing = place === undefined ? null : place.split(',').filter(Boolean);

  const changePlacing = (lineIds: string[] | null): void => {
    if (lineIds !== null) {
      openedFrom.current = reportId;
      void navigate({
        to: '/supply/$reportId',
        params: { reportId },
        search: { place: lineIds.join(',') },
      });
      return;
    }
    if (place === undefined) return;
    if (openedFrom.current === reportId) {
      router.history.back();
      return;
    }
    // Fallback: tarix yo'q — ro'yxatga emas, AYNAN shu hujjatga.
    void navigate({ to: '/supply/$reportId', params: { reportId }, search: {}, replace: true });
  };

  return (
    <SupplyDetailPage
      reportId={reportId}
      placing={placing}
      onPlacingChange={changePlacing}
      /* `/supply` marshruti `NAV_ITEMS` dan quriladi va shuning uchun
         yozilgan yo'llar ro'yxatiga tushmaydi — `AppShell` dagi kabi
         oddiy satr bo'lib qoladi. */
      onBack={() => void navigate({ to: SUPPLY_PATH as string })}
    />
  );
};
